import * as React from 'react';

import { Message as AIMessage } from '@ai-sdk/react';

import { Markdown } from './Markdown';
import { ToolInvocation } from './types';
import { generateDraftStudyFromToolArgs } from './utils';

interface ToolContentProps {
  message: AIMessage;
}

export const ToolContent: React.FC<ToolContentProps> = ({ message }) => {
  const toolResult = (message.toolInvocations as ToolInvocation[])
    ?.slice()
    .reverse()
    .find(
      (invocation) => invocation.toolName === 'save_draft_study_to_scratchpad' && invocation.args !== undefined
    )?.args;

  if (!toolResult) {
    return null;
  }

  // Determine content based on toolResult structure
  let content: string;

  if (typeof toolResult === 'string') {
    content = toolResult;
  } else if (
    toolResult &&
    typeof toolResult === 'object' &&
    Object.keys(toolResult).length === 1 &&
    'draft_study' in toolResult
  ) {
    content = generateDraftStudyFromToolArgs(toolResult);
  } else {
    content = JSON.stringify(toolResult, null, 2);
  }

  return (
    <div className='px-4 py-2 text-left text-gray-900'>
      <div className='prose prose-sm max-w-none text-sm leading-relaxed'>
        <Markdown content={content} />
      </div>
    </div>
  );
};
